import React from 'react'
import classNames from 'classnames'

const Photo = ({ clickHandler, htmlID, member, selectedIndex}) => {
  const { id, name, role, src} = member
  const triangleClasses = classNames({
    'down-triangle': true,
    'expandey': selectedIndex === id,
    'collapsey': selectedIndex !== id,
  })
  return (
    <div className="imageGridItem" id={id}>
      <a className={selectedIndex === id ? 'active' : null} onClick={ clickHandler ? clickHandler.bind(this, id) : null }>
        <div className="imageWrapper" style={{backgroundImage: `url(${src})`}}>
        <div className="imageDescription">
          <p className="name">{name}</p>
          <p className="role">{role}</p>
        </div>
        </div>
        <div className={triangleClasses}></div>
      </a>
    </div>
  );
};

export default Photo


// WEBPACK FOOTER //
// ./src/components/About/Photo.js